
export enum FileFundingStatus {
    "READY_FOR_FILE_UPLOADING" = "READY_FOR_FILE_UPLOADING",
    "READY_FOR_SIGNING" = "READY_FOR_SIGNING",
    "IN_PROGRESS_OF_SIGNING" = "IN_PROGRESS_OF_SIGNING",
    "SIGNED" = "SIGNED",
    "UPLOADED_AND_BLOCKED_FOR_SIGNING" = "UPLOADED_AND_BLOCKED_FOR_SIGNING",
    "WAITING_FOR_UPLOADING_BY_OTHER_PARTY" = "WAITING_FOR_UPLOADING_BY_OTHER_PARTY",
    "UPLOADED_BY_OTHER_PARTY_AND_READY_FOR_DOWNLOADING" = "UPLOADED_BY_OTHER_PARTY_AND_READY_FOR_DOWNLOADING"
}
export type FileFunding = {
    /**
     * @type string
    */
    status: FileFundingStatus;
    /**
     * @type string | undefined
    */
    documentId?: string;
    /**
     * @type string | undefined
    */
    originalFileName?: string;
    /**
     * @type string | undefined
    */
    signedFileName?: string;
    /**
     * @type boolean | undefined
    */
    canDownloadSignedFile?: boolean;
    /**
     * @type boolean | undefined
    */
    canFileBeChanged?: boolean;
};
